export default __webpack_public_path__ + "media/salad_banner_mobile.f22a3984.png";